"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ModalContext = require("../context/ModalContext");

var setImageOffset = function setImageOffset(_ref) {
  var offsetBottom = _ref.offsetBottom,
      offsetTop = _ref.offsetTop;
  return {
    marginBottom: offsetBottom,
    marginTop: offsetTop * -1
  };
};

var UIDialogHeaderImage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIDialogHeaderImage, _Component);

  function UIDialogHeaderImage() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIDialogHeaderImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIDialogHeaderImage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.updateHeaderOffset = function () {
      // Measuring offsetTop in the DOM is more accurate than using the offsetTop prop, because it
      // accounts for the padding above the element.
      var overflow = -1 * _this._el.offsetTop;

      if (overflow > 0) {
        _this._headerCallback(overflow);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UIDialogHeaderImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateHeaderOffset(); // The offset can change based on breakpoints, e.g. because padding is reduced for mobile.

      window.addEventListener('resize', this.updateHeaderOffset);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateHeaderOffset();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateHeaderOffset);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          offsetBottom = _this$props.offsetBottom,
          offsetTop = _this$props.offsetTop,
          style = _this$props.style,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "offsetBottom", "offsetTop", "style"]);
      return _react.default.createElement(_ModalContext.ModalContextConsumer, null, function (_ref2) {
        var headerCallback = _ref2.headerCallback;
        _this2._headerCallback = headerCallback;
        return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
          className: (0, _classnames.default)('private-modal__header-image', className),
          ref: function ref(_ref3) {
            _this2._el = _ref3;
          },
          style: (0, _extends2.default)({}, setImageOffset({
            offsetBottom: offsetBottom,
            offsetTop: offsetTop
          }), style)
        }), children);
      });
    }
  }]);
  return UIDialogHeaderImage;
}(_react.Component);

exports.default = UIDialogHeaderImage;
UIDialogHeaderImage.propTypes = {
  children: _propTypes.default.node,
  offsetBottom: _propTypes.default.number,
  offsetTop: _propTypes.default.number
};
UIDialogHeaderImage.displayName = 'UIDialogHeaderImage';
module.exports = exports.default;